export const resetted = Symbol('resetted')
export const submitted = Symbol('submitted')
export const rendered = Symbol('rendered')
